import { useAuth0 } from "@auth0/auth0-react";
import FinanceService from "Lib/API/Finance";
import Action from "components/ActionPopOver";
import AlertDialog from "components/Dialog";
import MyTable from "components/Table";
import { searchRequest } from "hook/searchRequest";
import React, { useState } from "react";
import { useHistory } from "react-router";

import { toastr } from "react-redux-toastr";
import "../index.scss";
const ProductDetailTable = ({
  setEdit,
  setData,
  setEditClicked,
  refresh,
  setRefresh,
  setIdObject,
  searchText,
  subValue,
  ledgerValue,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [list, setList] = React.useState([]);
  const [productId, setProductId] = React.useState("");
  const [openAlert, setOpenAlert] = React.useState(false);
  const [table, setTable] = React.useState([]);
  const [deleteClicked, setDeleteClicked] = React.useState(false);
  const rowsPerPage = 15;
  const { getAccessTokenSilently } = useAuth0();
  const history = useHistory();

  const enableLoading = (value) => {
    setLoading(value);
  };

  const handleCloseDialog = () => {
    setOpenAlert(false);
  };
  const handleChange = async () => {
    const token = await getAccessTokenSilently();
    await FinanceService.updateProduct(
      { product_id: productId, activated: false },
      token
    )
      .then((res) => {
        if (res) {
          setOpenAlert(false);
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };
  const handleDelete = async () => {
    const token = await getAccessTokenSilently();
    await FinanceService.removeProduct({ product_id: productId }, token)
      .then((res) => {
        if (res) {
          handleCloseDialog();
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);

      });
  };
  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      const idLength = history.location.pathname?.split("/").length;
      const id = history?.location?.pathname?.split("/")[idLength - 1];

      if (id === "1") {
        await FinanceService.getFilteredProducts("filter?active=true", token)
          .then((res) => {
            if (res.length) {
              res.map((item) => {
                item.id = item._id;
                return item;
              });
              setList(res);
              setTable(res);
            } else setList([]);
            enableLoading(false);
          })
          .catch((err) => {
            enableLoading(false);
            toastr.error("Error", err?.data?.message);

          });
      } else {
        if (history?.location?.state?.subId?.length) {
          setIdObject(history?.location?.state);
          await FinanceService.getProductsBySubCat(
            "?active=true",
            subValue?.value,
            token
          )
            .then((res) => {
              if (res.length) {
                res.map((item) => {
                  item.id = item._id;
                  return item;
                });
                setList(res);
                setTable(res);
              } else setList([]);
              enableLoading(false);
            })
            .catch((err) => {
              enableLoading(false);
              toastr.error("Error", err?.data?.message);
            });
        } else
          await FinanceService.getProductsByLedgerAccount(
            "?active=true",
            id,
            token
          )
            .then((res) => {
              if (res.length) {
                res.map((item) => {
                  item.id = item._id;
                  return item;
                });
                setList(res);
                setTable(res);
              } else setList([]);
              enableLoading(false);
            })
            .catch((err) => {
              enableLoading(false);
              toastr.error("Error", err?.data?.message);
            });
      }
    }
    fetchMyAPI();
    enableLoading(true);
  }, [getAccessTokenSilently, history, refresh, subValue]);
  const columns = [
    {
      field: "prod_id",
      resizable: true,
      headerName: "ID",
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (data) => {
        return <div style={{ fontSize: "14px" }}>{data?.row?.prod_id}</div>;
      },
    },
    {
      field: "prod_name",
      resizable: true,
      headerName: "PRODUCT NAME",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (data) => {
        return (
          <div style={{ fontSize: "14px", color: "grey" }}>
            {" "}
            {data?.row?.prod_name}
          </div>
        );
      },
    },
    {
      field: "description",
      resizable: true,
      headerName: "DESCRIPTION",
      minWidth: 250,
      sortable: false,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "grey" }}>
          {data?.row?.description}
        </div>
      ),
    },
    {
      field: "year",
      resizable: true,
      headerName: "YEAR",
      sortable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (data) => (
        <div style={{ fontSize: "14px" }}>{data?.row?.year}</div>
      ),
    },
    {
      field: "price",
      resizable: true,
      headerName: "PRICE",
      sortable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "#4fb152" }}>
          {data?.row?.price}
        </div>
      ),
    },
    {
      field: "action",
      resizable: true,
      headerName: `${" "}`,
      sortable: false,
      minWidth: 15,
      renderCell: () => (
        <div style={{ cursor: "pointer" }}>
          <Action
            onEditClick={() => {
              setEdit(true);
              setEditClicked(true);
            }}
            onDeleteClick={() => {
              setDeleteClicked(true);
              setOpenAlert(true);
            }}
            onActiveClick={() => {
              setOpenAlert(true);
            }}
            checkActive={true}
          />
        </div>
      ),
    },
  ];

  React.useEffect(() => {
    searchRequest(searchText, table, setList);
  }, [searchText]);

  return (
    <div className="activated-ledger">
      <div className="ledger-table" style={{ height: "fit-content" }}>
        <div className="table-title">
          {/* {list[0]?.led_account?.led_acc_name} */}
        </div>
        <div className="home-table-container mt-0 ">
          <MyTable
            className="family-table"
            rows={list}
            columns={columns}
            pageSize={6}
            loading={loading}
            rowHeight={65}
            onClickEvent={(params, event) => {
              event.defaultMuiPrevented = true;
              setData(params?.row);
              setProductId(params?.row?._id);
            }}
          >
            Rows per page: {rowsPerPage}
          </MyTable>
          <AlertDialog
            open={openAlert}
            handleClose={handleCloseDialog}
            onDecline={() => {
              setOpenAlert(false);
            }}
            onAccept={() => {
              deleteClicked ? handleDelete() : handleChange();
            }}
            title={"Are you sure?"}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductDetailTable;
